import { Icon, type IconProps } from "@chakra-ui/react";

const BrandTickInactiveIcon = (props: IconProps) => {
	return (
		<Icon
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g clipPath="url(#clip0_10508_22062)">
				<rect width="24" height="24" rx="12" fill="white" />
				<rect
					x="0.75"
					y="0.75"
					width="22.5"
					height="22.5"
					rx="11.25"
					stroke="#EAECF0"
					strokeWidth="1.5"
				/>
				<circle cx="12" cy="12" r="4" fill="#D0D5DD" />
			</g>
			<defs>
				<clipPath id="clip0_10508_22062">
					<rect width="24" height="24" rx="12" fill="white" />
				</clipPath>
			</defs>
		</Icon>
	);
};

export default BrandTickInactiveIcon;
